import { useScheduleGroup } from "routes/facilities/lib/use-schedule-group"
import { Box, Button, Typography } from "@mui/material"
import { BoundTextEditor } from "minimals-template/components/editor"
import { useState } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RegimeDraftLockTooltip } from "../regime-draft-locking/regime-draft-lock-tooltip"
import { RegimeDraftLockHide } from "../regime-draft-locking/regime-draft-lock-hide"

export function AdditionalNotes() {
    const name = useScheduleGroup()
    const { target, individualTask, hasAdvancedTailoring } = useBoundContext()
    const [show, setShow] = useState(!!target.notes)

    const button = hasAdvancedTailoring && (
        <RegimeDraftLockHide>
            <Button variant="outlined" size="small" onClick={() => setShow(true)} data-cy="additional-notes-button">
                Add Notes {!!name && "for"} {name}
            </Button>
        </RegimeDraftLockHide>
    )

    const content = hasAdvancedTailoring ? (
        <RegimeDraftLockTooltip>
            <BoundTextEditor field="notes" label={`Additional notes ${name ? "for" : ""} ${name}`} />
        </RegimeDraftLockTooltip>
    ) : (
        <Typography dangerouslySetInnerHTML={{ __html: target.notes }} />
    )

    return (
        !individualTask && (
            <Box p={1} pr={6}>
                {show ? content : button}
            </Box>
        )
    )
}
